import isFunction = require('lodash/isFunction');

const isFirefox: boolean = navigator.userAgent.includes('Firefox');
const supportedConstraints = navigator.mediaDevices && isFunction(navigator.mediaDevices.getSupportedConstraints)
  ? navigator.mediaDevices.getSupportedConstraints()
  : {};

const VIDEO_QUALITY = {
  high: {
    maxFrameRate: 60,
  },

  good: {
    maxFrameRate: 30,
  },

  low: {
    maxFrameRate: 10,
  },
};

const VIDEO_SIZE = {
  maxHeight: 180,
  minHeight: 180,
  maxWidth: 180,
  minWidth: 180,
};

const frameRate = (videoQualityId: string) => {
  if (!supportedConstraints.frameRate) {
    return {};
  }

  if (isFirefox) {
    const {maxFrameRate: max} = VIDEO_QUALITY[videoQualityId];

    return {
      frameRate: {max},
    };
  }

  return VIDEO_QUALITY[videoQualityId];
};

export const videoConstraints = (deviceId: string, videoQualityId: string, defaultVideoSize?: boolean) => {
  if (isFirefox) {
    const {maxWidth: width, maxHeight: height} = VIDEO_SIZE;

    return {
      ...defaultVideoSize ? {width, height} : {},
      ...frameRate(videoQualityId),
      deviceId,
    };
  }

  return {
    deviceId: deviceId || undefined,
    ...defaultVideoSize ? VIDEO_SIZE : {},
    ...frameRate(videoQualityId),
  };
};
